import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/frontend/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/vercel/path0/frontend/src/components/ui/Button.tsx");
